import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "eye",
  "use": "eye-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"eye\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.333 8C12.89 4.333 10.444 2.5 8 2.5S3.111 4.333.667 8C3.11 11.667 5.556 13.5 8 13.5s4.889-1.833 7.333-5.5zm-1.212 0c-2.14 3.04-4.195 4.5-6.121 4.5-1.926 0-3.98-1.46-6.121-4.5C4.019 4.96 6.074 3.5 8 3.5c1.926 0 3.98 1.46 6.121 4.5zM8 10.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5zM9.5 8a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol